import { useState } from 'react';
import { Copy, Check } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

interface QrDisplayProps {
  qrImageBase64: string;
  qrPayload: string;
}

export function QrDisplay({ qrImageBase64, qrPayload }: QrDisplayProps) {
  const [copied, setCopied] = useState(false);

  async function handleCopy() {
    try {
      await navigator.clipboard.writeText(qrPayload);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Clipboard API may be unavailable in some environments
    }
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>QR Code</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        {qrImageBase64 ? (
          <div className="flex justify-center">
            <img
              src={`data:image/png;base64,${qrImageBase64}`}
              alt="PayNow QR Code"
              className="h-56 w-56 rounded-lg border border-slate-200"
            />
          </div>
        ) : (
          <div className="flex h-56 w-56 items-center justify-center rounded-lg border border-dashed border-slate-300 text-sm text-slate-400">
            No QR image
          </div>
        )}

        <div>
          <p className="mb-1 text-xs font-medium text-slate-500">QR Payload</p>
          <div className="rounded-md bg-slate-50 p-3">
            <p className="break-all font-mono text-xs text-slate-700">{qrPayload || '—'}</p>
          </div>
        </div>

        {qrPayload && (
          <Button variant="outline" size="sm" onClick={handleCopy} className="w-full">
            {copied ? (
              <>
                <Check className="h-4 w-4" />
                Copied
              </>
            ) : (
              <>
                <Copy className="h-4 w-4" />
                Copy QR Payload
              </>
            )}
          </Button>
        )}
      </CardContent>
    </Card>
  );
}
